// src/pages/TenantIndisponivelPage.jsx
import { Building2, PauseCircle } from 'lucide-react';
import { useDarkMode } from '@/hooks/useDarkMode';

/**
 * Exibida no lugar do app quando o condomínio do endereço não existe no cadastro
 * ou está suspenso (spec onboarding-tenant, RF-07). Renderizada antes do login.
 *
 * @param {{ codigo: string, status: 'NaoEncontrado' | 'Suspenso', nome?: string | null }} props
 */
export function TenantIndisponivelPage({ codigo, status, nome = null }) {
  useDarkMode(); // fora do App: aplica o tema (escuro por padrão) por conta própria
  const suspenso = status === 'Suspenso';
  const Icon = suspenso ? PauseCircle : Building2;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
          <Icon className="h-8 w-8 text-amber-600 dark:text-amber-400" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          {suspenso ? 'Acesso suspenso' : 'Condomínio não encontrado'}
        </h2>

        <p className="text-sm text-gray-600 dark:text-gray-400">
          {suspenso
            ? `O acesso ao O Porteiro de ${nome || codigo} está suspenso no momento. Fale com a administração do condomínio.`
            : `Não há um condomínio "${codigo}" no O Porteiro. Confira o endereço digitado.`}
        </p>
      </div>
    </div>
  );
}
